try {
  self["workbox:window:4.3.1"] && _();
} catch (n) {}

var n = function n(_n, t) {
  return new Promise(function (i) {
    var e = new MessageChannel();
    e.port1.onmessage = function (n) {
      return i(n.data);
    }, _n.postMessage(t, [e.port2]);
  });
};

function t(n, t) {
  for (var i = 0; i < t.length; i++) {
    var e = t[i];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(n, e.key, e);
  }
}

function i(n) {
  if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}

try {
  self["workbox:core:4.3.1"] && _();
} catch (n) {}

var e = function e() {
  var n = this;
  this.promise = new Promise(function (t, i) {
    n.resolve = t, n.reject = i;
  });
},
    r = function r(n, t) {
  return new URL(n, location).href === new URL(t, location).href;
},
    o = function o(n, t) {
  Object.assign(this, t, {
    type: n
  });
};

function u(n) {
  return function () {
    for (var t = [], i = 0; i < arguments.length; i++) {
      t[i] = arguments[i];
    }

    try {
      return Promise.resolve(n.apply(this, t));
    } catch (n) {
      return Promise.reject(n);
    }
  };
}

function a(n, t, i) {
  return i ? t ? t(n) : n : (n && n.then || (n = Promise.resolve(n)), t ? n.then(t) : n);
}

function s() {}

var c = function (c) {
  var f, h;

  function v(n, t) {
    var r;
    return void 0 === t && (t = {}), (r = c.call(this) || this).t = n, r.i = t, r.o = 0, r.u = new e(), r.s = new e(), r.h = new e(), r.v = r.v.bind(i(i(r))), r.l = r.l.bind(i(i(r))), r.g = r.g.bind(i(i(r))), r.m = r.m.bind(i(i(r))), r;
  }

  h = c, (f = v).prototype = Object.create(h.prototype), f.prototype.constructor = f, f.__proto__ = h;
  var l,
      w,
      g,
      d = v.prototype;
  return d.register = u(function (n) {
    var t,
        i,
        e = this,
        u = (void 0 === n ? {} : n).immediate,
        c = void 0 !== u && u;
    return t = function t() {
      return e.p = Boolean(navigator.serviceWorker.controller), e.P = e.R(), a(e.k(), function (n) {
        e.B = n, e.P && (e.O = e.P, e.s.resolve(e.P), e.h.resolve(e.P), e.j(e.P), e.P.addEventListener("statechange", e.l, {
          once: !0
        }));
        var t = e.B.waiting;
        return t && r(t.scriptURL, e.t) && (e.O = t, Promise.resolve().then(function () {
          e.dispatchEvent(new o("waiting", {
            sw: t,
            wasWaitingBeforeRegister: !0
          }));
        })), e.O && e.u.resolve(e.O), e.B.addEventListener("updatefound", e.g), navigator.serviceWorker.addEventListener("controllerchange", e.m, {
          once: !0
        }), "BroadcastChannel" in self && (e.C = new BroadcastChannel("workbox"), e.C.addEventListener("message", e.v)), navigator.serviceWorker.addEventListener("message", e.v), e.B;
      });
    }, (i = function () {
      if (!c && "complete" !== document.readyState) return function (n, t) {
        if (!t) return n && n.then ? n.then(s) : Promise.resolve();
      }(new Promise(function (n) {
        return addEventListener("load", n);
      }));
    }()) && i.then ? i.then(t) : t(i);
  }), d.getSW = u(function () {
    return this.O || this.u.promise;
  }), d.messageSW = u(function (t) {
    return a(this.getSW(), function (i) {
      return n(i, t);
    });
  }), d.R = function () {
    var n = navigator.serviceWorker.controller;
    if (n && r(n.scriptURL, this.t)) return n;
  }, d.k = u(function () {
    var n = this;
    return function (n, t) {
      try {
        var i = n();
      } catch (n) {
        return t(n);
      }

      return i && i.then ? i.then(void 0, t) : i;
    }(function () {
      return a(navigator.serviceWorker.register(n.t, n.i), function (t) {
        return n.L = performance.now(), t;
      });
    }, function (n) {
      throw n;
    });
  }), d.j = function (t) {
    n(t, {
      type: "WINDOW_READY",
      meta: "workbox-window"
    });
  }, d.g = function () {
    var n = this.B.installing;
    this.o > 0 || !r(n.scriptURL, this.t) || performance.now() > this.L + 6e4 ? (this.W = n, this.B.removeEventListener("updatefound", this.g)) : (this.O = n, this.u.resolve(n)), ++this.o, n.addEventListener("statechange", this.l);
  }, d.l = function (n) {
    var t = this,
        i = n.target,
        e = i.state,
        r = i === this.W,
        u = r ? "external" : "",
        a = {
      sw: i,
      originalEvent: n
    };
    !r && this.p && (a.isUpdate = !0), this.dispatchEvent(new o(u + e, a)), "installed" === e ? this._ = setTimeout(function () {
      "installed" === e && t.B.waiting === i && t.dispatchEvent(new o(u + "waiting", a));
    }, 200) : "activating" === e && (clearTimeout(this._), r || this.s.resolve(i));
  }, d.m = function (n) {
    var t = this.O;
    t === navigator.serviceWorker.controller && (this.dispatchEvent(new o("controlling", {
      sw: t,
      originalEvent: n
    })), this.h.resolve(t));
  }, d.v = function (n) {
    var t = n.data;
    this.dispatchEvent(new o("message", {
      data: t,
      originalEvent: n
    }));
  }, l = v, (w = [{
    key: "active",
    get: function get() {
      return this.s.promise;
    }
  }, {
    key: "controlling",
    get: function get() {
      return this.h.promise;
    }
  }]) && t(l.prototype, w), g && t(l, g), v;
}(function () {
  function n() {
    this.D = {};
  }

  var t = n.prototype;
  return t.addEventListener = function (n, t) {
    this.T(n).add(t);
  }, t.removeEventListener = function (n, t) {
    this.T(n).delete(t);
  }, t.dispatchEvent = function (n) {
    n.target = this, this.T(n.type).forEach(function (t) {
      return t(n);
    });
  }, t.T = function (n) {
    return this.D[n] = this.D[n] || new Set();
  }, n;
}());

export { c as Workbox, n as messageSW };